
import { useState } from "react";
import { formatDate } from "@/utils/dateUtils";
import TripDetail from "./TripDetail";
import { getAssetPath } from "@/utils/assetUtils";
import { isTripCompleted } from "@/utils/tripFormatUtils";
import { TripData } from "@/types/trip";
import TripCardHeader from "./trip/TripCardHeader";
import TripCardDetails from "./trip/TripCardDetails";
import TripPriceDisplay from "./trip/TripPriceDisplay";
import TripActionButtons from "./trip/TripActionButtons";

interface TripCardProps extends TripData {
  onClaimTrip?: (tripId: string) => void;
}

const TripCard = ({ 
  community_event,
  pickup_at,
  passenger_count = 0,
  organization_price = 1000,
  booking_duration = 0,
  claimed_by,
  id,
  to_address,
  from_address,
  is_round_trip,
  onClaimTrip,
  rating = 0,
  rating_count = 0,
  status,
  mobile_number
}: TripCardProps) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  
  const formattedDate = formatDate(pickup_at);
  const isCompleted = isTripCompleted(status, claimed_by);
  
  // Determine which background image to use based on trip status
  const backgroundImage = isCompleted 
    ? "Completed_Trip_Card_Background.png"
    : "Dashboard_Trip_Card_Background.png";
  
  console.log(`Trip ID ${id} status: ${status}, claimed_by: ${claimed_by}, isCompleted: ${isCompleted}`);
  
  return (
    <>
      <div 
        className="rounded-xl overflow-hidden shadow-lg w-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:scale-[1.02]"
        style={{ 
          backgroundImage: `url(${getAssetPath(backgroundImage)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: isCompleted ? 'white' : 'black',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div className="p-4">
          <TripCardHeader 
            community_event={community_event}
            to_address={to_address}
            isCompleted={isCompleted}
          />

          <TripCardDetails 
            passenger_count={passenger_count} 
            booking_duration={booking_duration}
            is_round_trip={is_round_trip}
            isCompleted={isCompleted}
            onViewMoreClick={() => setIsDetailOpen(true)}
          />

          <TripPriceDisplay 
            date={formattedDate} 
            price={organization_price} 
            isCompleted={isCompleted}
          />
        </div>
        
        <TripActionButtons 
          claimed_by={claimed_by}
          isCompleted={isCompleted}
          onClaimTrip={() => onClaimTrip && onClaimTrip(id)}
          tripId={id}
          mobile_number={mobile_number}
        />
      </div>

      <TripDetail
        isOpen={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
        community_event={community_event}
        pickup_at={pickup_at}
        passenger_count={passenger_count}
        organization_price={organization_price}
        booking_duration={booking_duration}
        claimed_by={claimed_by}
        id={id}
        to_address={to_address}
        from_address={from_address}
        is_round_trip={is_round_trip}
        onClaimTrip={onClaimTrip}
        rating={rating}
        rating_count={rating_count}
        status={status}
        mobile_number={mobile_number}
      />
    </>
  );
};

export default TripCard;
